import PageHead from "../Head";
import HeaderContainer from "@/my_components/Header/HeaderContainer";
import Separator from "@/components/Common/Separator";
import KnowledgeBase from "@/my_components/_FAQ/KnowledgeBase";
import MobileMenu from "@/my_components/Header/MobileMenu";
import BackToTop from "@/my_components/BackToTop/BackToTop_1";

import Context from "@/context/Context";
import Footer from "@/my_components/Footer/Footer";

const index = () => {

  return (

    <>

        <PageHead title="Knowledge Base | SmartTech Academy" />

            <Context>
                <MobileMenu />
                <HeaderContainer headerSticky="rbt-sticky" headerType="" />
                <KnowledgeBase />
                <BackToTop />

                <Separator />
                <Footer />
            </Context>
    </>

  );

};

export default index;
